import { ISanityItemOption } from '@rbi-ctg/menu';

export const shouldDisplayItemOptionGroup = (() => true) as (
  groupOptions: ISanityItemOption[]
) => boolean;
